import { m } from '@sohanscript/i18n';
import { useParams } from '@tanstack/react-router';
import type { ComponentProps } from 'react';
import { PageNav } from '@/components/page-nav';
import { localizeServices } from '@/lib/data/services-i18n';

type ServiceNavProps = ComponentProps<'nav'>;

export function ServiceNav({ ...props }: ServiceNavProps) {
	const { slug } = useParams({ from: '/_main/build/$slug' });

	const items = localizeServices().map((s) => ({
		slug: s.slug,
		title: s.title,
	}));

	return (
		<PageNav
			currentSlug={slug}
			itemTo="/build/$slug"
			listTo="/services"
			listLabel={m.svc_all()}
			items={items}
			{...props}
		/>
	);
}
